const CommunityGuidelinesPage = () => (
  <div className="mx-auto max-w-2xl space-y-6" data-testid="community-guidelines-page">
    <h2 className="text-2xl font-semibold" data-testid="community-guidelines-title">
      YOPINION COMMUNITY GUIDELINES
    </h2>
    <div className="space-y-6 text-sm leading-relaxed text-muted-foreground" data-testid="community-guidelines-content">
      <p>Last updated: May 2026</p>
      <p>
        Yopinion is built for opinions, not conflict. Keep it respectful, clear, and useful for
        everyone.
      </p>

      <div>
        <p className="font-medium text-foreground">1. Keep it respectful</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>No hate speech, harassment, or personal attacks</li>
          <li>No targeting individuals or groups</li>
          <li>Disagree with ideas, not people</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">2. No harmful or illegal content</p>
        <p className="mt-1">Do not post polls that include:</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Violence or threats</li>
          <li>Illegal activities</li>
          <li>Self-harm or dangerous behavior</li>
          <li>Explicit or adult content</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">3. No misleading or manipulative polls</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Don't create intentionally misleading questions</li>
          <li>Avoid biased framing to influence results unfairly</li>
          <li>No fake or spam polls</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">4. No sensitive personal data</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Do not share private information</li>
          <li>Do not create polls about specific individuals without consent</li>
          <li>Avoid questions that invade privacy</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">5. Keep polls clear and meaningful</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Ask simple, understandable questions</li>
          <li>Avoid unnecessary complexity</li>
          <li>Make options relevant and fair</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">6. No spam or excessive posting</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Don't flood the platform with repetitive polls</li>
          <li>Avoid promotional or irrelevant content</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">7. Platform is for opinions, not facts</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Poll results reflect what people think</li>
          <li>They are not verified truth or expert advice</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">8. Respect the community</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Engage honestly</li>
          <li>Vote fairly</li>
          <li>Help keep the platform useful</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">9. Enforcement</p>
        <p className="mt-1">We may:</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Remove polls or content</li>
          <li>Limit account activity</li>
          <li>Suspend or ban accounts</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">10. Evolving guidelines</p>
        <p className="mt-1">These guidelines may evolve as the community grows.</p>
      </div>
    </div>
  </div>
);

export default CommunityGuidelinesPage;
